import {decode} from 'html-entities'
import {
  CHANNEL_MESSAGE,
  CHANNEL_NAME,
  ERR_NO_CACHE,
  ERR_NO_CACHE_NETWORK,
  ERR_NO_NETWORK,
} from './config'
import {BroadcastChannel} from 'broadcast-channel'

export function decodeEntities(s) {
  return decode(s);
}

export const broadcastError = async (err_code) => {
  const bc = window.BroadcastChannel ? new window.BroadcastChannel(CHANNEL_NAME) : new BroadcastChannel(CHANNEL_NAME)
  await bc.postMessage({
    ...CHANNEL_MESSAGE,
    error: true,
    code: err_code,
    title: err_code === ERR_NO_CACHE ? 'Browserfehler' : 'Netzwerkfehler',
    message: err_code === ERR_NO_CACHE ?
      'Es ist ein Fehler aufgetreten. Bitte beachten Sie, dass diese App nicht im privaten Modus funktioniert.' :
      `Offenbar gibt es gerade Verbindungsprobleme.
    ${err_code === ERR_NO_CACHE_NETWORK ? ' Bitte probieren Sie es später noch einmal.' : ''}
    ${err_code === ERR_NO_NETWORK ? ' Daten könnten veraltet sein.' : ''}`,
  })
}
